import { IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react';
import { SupportedTranscriptionLocales } from '../../../utils/TranscriptionLanguages';
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getFileInputStyles = () => {
  return AppLayoutSettings.AppCommonStyles.getFileInputStyles(AppLayoutSettings.AppDisplayType.none);
};

export const getDropdownStyles = (): Partial<IDropdownStyles> => {
  return {
    dropdown: {
      width: '100%'
    },
    title: {
      color: `${AppLayoutSettings.getAppColorContainer().mediumLabelColor.value} !important`,
      backgroundColor: `${AppLayoutSettings.getAppColorContainer().secondaryWidgetColor.value} !important`
    },
    dropdownItem: {
      color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
      selectors: {
        [`:hover, :focus, :active`] : {
          color: 'windowText !important',
          backgroundColor: `${AppLayoutSettings.getAppColorContainer().dropDownHoverColor.value} !important`
        }
      }
    },
    dropdownItemSelected: {
      backgroundColor: `${AppLayoutSettings.getAppColorContainer().dropDownSelectionColor.value} !important`
    },
    caretDown: {
      color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
      backgroundColor: AppLayoutSettings.getAppColorContainer().secondaryWidgetColor.value
    },
    subComponentStyles: {
      panel: {
        main: {
          backgroundColor: AppLayoutSettings.getAppColorContainer().secondaryWidgetColor.value,
        }
      },
      label: {},
      multiSelectItem: {}
    }
  }
};

export const getSupportedTranscriptionLanguages = (): IDropdownOption[] => {
  let languageOptions: IDropdownOption[] = [];
  SupportedTranscriptionLocales.forEach((value: string, _index: number, _array: string[]) => {
    switch (value) {
      case 'ar-BH':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicBahrainmodernstandard });
        break;
      case 'ar-EG':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicEgypt });
        break;
      case 'ar-IQ':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicIraq });
        break;
      case 'ar-JO':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicJordan });
        break;
      case 'ar-KW':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicKuwait });
        break;
      case 'ar-LB':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicLebanon });
        break;
      case 'ar-OM':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicOman });
        break;
      case 'ar-QA':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicQatar });
        break;
      case 'ar-SA':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicSaudiArabia });
        break;
      case 'ar-SY':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicSyria });
        break;
      case 'ar-AE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelArabicUnitedArabEmirates });
        break;
      case 'bg-BG':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelBulgarianBulgaria });
        break;
      case 'ca-ES':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelCatalanSpain });
        break;
      case 'zh-HK':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelChineseCantoneseTraditional });
        break;
      case 'zh-CN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelChineseMandarinSimplified });
        break;
      case 'zh-TW':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelChineseTaiwaneseMandarin });
        break;
      case 'hr-HR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelCroatianCroatia });
        break;
      case 'cs-CZ':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelCzechCzechRepublic });
        break;
      case 'da-DK':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelDanishDenmark });
        break;
      case 'nl-NL':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelDutchNetherlands });
        break;
      case 'en-AU':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishAustralia });
        break;
      case 'en-CA':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishCanada });
        break;
      case 'en-HK':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishHongKongSAR });
        break;
      case 'en-IN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishIndia });
        break;
      case 'en-IE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishIreland });
        break;
      case 'en-NZ':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishNewZealand });
        break;
      case 'en-PH':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishPhilippines });
        break;
      case 'en-SG':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishSingapore });
        break;
      case 'en-ZA':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishSouthAfrica });
        break;
      case 'en-GB':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishUnitedKingdom });
        break;
      case 'en-US':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEnglishUnitedStates });
        break;
      case 'et-EE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelEstonianEstonia });
        break;
      case 'fi-FI':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelFinnishFinland });
        break;
      case 'fr-CA':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelFrenchCanada });
        break;
      case 'fr-FR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelFrenchFrance });
        break;
      case 'de-DE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelGermanGermany });
        break;
      case 'el-GR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelGreekGreece });
        break;
      case 'gu-IN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelGujaratiIndian });
        break;
      case 'hi-IN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelHindiIndia });
        break;
      case 'hu-HU':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelHungarianHungary });
        break;
      case 'ga-IE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelIrishIreland });
        break;
      case 'it-IT':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelItalianItaly });
        break;
      case 'ja-JP':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelJapaneseJapan });
        break;
      case 'ko-KR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelKoreanKorea });
        break;
      case 'lv-LV':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelLatvianLatvia });
        break;
      case 'lt-LT':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelLithuanianLithuania });
        break;
      case 'mt-MT':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelMalteseMalta });
        break;
      case 'mr-IN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelMarathiIndia });
        break;
      case 'nb-NO':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelNorwegianBokmalNorway });
        break;
      case 'pl-PL':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelPolishPoland });
        break;
      case 'pt-BR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelPortugueseBrazil });
        break;
      case 'pt-PT':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelPortuguesePortugal });
        break;
      case 'ro-RO':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelRomanianRomania });
        break;
      case 'ru-RU':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelRussianRussia });
        break;
      case 'sk-SK':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSlovakSlovakia });
        break;
      case 'sl-SI':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSlovenianSlovenia });
        break;
      case 'es-AR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishArgentina });
        break;
      case 'es-BO':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishBolivia });
        break;
      case 'es-CL':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishChile });
        break;
      case 'es-CO':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishColombia });
        break;
      case 'es-CR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishCostaRica });
        break;
      case 'es-CU':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishCuba });
        break;
      case 'es-DO':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishDominicanRepublic });
        break;
      case 'es-EC':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishEcuador });
        break;
      case 'es-SV':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishElSalvador });
        break;
      case 'es-GT':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishGuatemala });
        break;
      case 'es-HN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishHonduras });
        break;
      case 'es-MX':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishMexico });
        break;
      case 'es-NI':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishNicaragua });
        break;
      case 'es-PA':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishPanama });
        break;
      case 'es-PY':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishParaguay });
        break;
      case 'es-PE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishPeru });
        break;
      case 'es-PR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishPuertoRico });
        break;
      case 'es-ES':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishSpain });
        break;
      case 'es-UY':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishUruguay });
        break;
      case 'es-US':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishUSA });
        break;
      case 'es-VE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSpanishVenezuela });
        break;
      case 'sv-SE':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelSwedishSweden });
        break;
      case 'ta-IN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelTamilIndia });
        break;
      case 'te-IN':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelTeluguIndia });
        break;
      case 'th-TH':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelThaiThailand });
        break;
      case 'tr-TR':
        languageOptions.push({ key:value, text: TranscriptionStrings.LangDisplayLabelTurkishTurkey });
        break;
    }
  });

  return languageOptions;
}